import React from 'react';
import { useTranslation } from 'react-i18next';
import { pathManager } from 'routes';

import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { RouterButton } from '@libs/ui/components/button';
import Typography from '@libs/ui/components/typography';

import img1 from './icons/1@2x.png';
import img2 from './icons/2@2x.png';
import img3 from './icons/3@2x.png';

interface HowItWorksProps {}

const CARD_ITEMS = [
  {
    textKey: 'main.howItWorks.step1',
    icon: img1,
  },
  {
    textKey: 'main.howItWorks.step2',
    icon: img2,
  },
  {
    textKey: 'main.howItWorks.step3',
    icon: img3,
  },
];

const useStyles = makeStyles(() => ({
  card: {
    padding: '24px !important',
    background: 'white',
    maxWidth: 670,
    margin: '0 auto',
    borderRadius: 16,
    marginTop: 12,
  },
}));

export const HowItWorks = (props: HowItWorksProps) => {
  const { t } = useTranslation('careerHub');
  const classes = useStyles();

  return (
    <div>
      <Grid container flexDirection="column" spacing={{ xs: 4, sm: 6 }}>
        <Grid item>
          <Typography
            variant="overline"
            color="info.main"
            transform="uppercase"
            textAlign="center"
            component="div"
          >
            {t('main.howItWorks.title')}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h6" textAlign="center" fontWeight={500}>
            {t('main.howItWorks.subtitle')}
          </Typography>
        </Grid>
        <Grid item>
          <Box className={classes.card}>
            <Grid item container justifyContent="space-between">
              {CARD_ITEMS.map((i) => (
                <Grid item key={i.textKey}>
                  <Grid container flexDirection="column" spacing={4}>
                    <Grid item container justifyContent="center">
                      <img srcSet={`${i.icon} 2x`} alt={t(i.textKey)} />
                    </Grid>
                    <Grid item>
                      <Typography>{t(i.textKey)}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid container mt={6} justifyContent="center">
              <Grid item>
                <RouterButton
                  variant="contained"
                  color="info"
                  to={pathManager.talent.careerHub.pricing.generatePath()}
                >
                  {t('main.howItWorks.cta')}
                </RouterButton>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
